import * as Sentry from "@sentry/react";

type LogContext = Record<string, unknown>;

export const logger = {
  debug(message: string, context?: LogContext): void {
    if (import.meta.env.DEV) {
      console.log(message, context);
    } else {
      Sentry.logger.debug(message, context);
    }
  },

  info(message: string, context?: LogContext): void {
    if (import.meta.env.DEV) {
      console.info(message, context);
    } else {
      Sentry.logger.info(message, context);
    }
  },

  warn(message: string, context?: LogContext): void {
    if (import.meta.env.DEV) {
      console.warn(message, context);
    } else {
      Sentry.logger.warn(message, context);
    }
  },

  error(message: string | Error, context?: LogContext): void {
    if (import.meta.env.DEV) {
      console.error("Error:", message, context);
    } else {
      Sentry.withScope((scope) => {
        scope.setContext("page", {
          url: window.location.href,
          pathname: window.location.pathname,
          search: window.location.search,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        });

        if (context) {
          scope.setContext("errorContext", context);
        }

        scope.setLevel("error");

        if (typeof message === "string") {
          Sentry.captureMessage(message, "error");
        } else {
          Sentry.captureException(message);
        }
      });
    }
  },
} as const;
